import { createSelector } from "@reduxjs/toolkit";
import { MainData } from "../../types/state";
import { RootState } from "src/store/rootReducer";
import { NameSpace } from "../../const";

export const getDataMain = createSelector(
  (state: RootState) => state.vpoStrapi[NameSpace.DataMain],
  (state: MainData) => state.data
);

export const getFetchingStatusMainData = createSelector(
  (state: RootState) => state.vpoStrapi[NameSpace.DataMain],
  (state: MainData) => state.fetchingStatusMainData
);
